export default "__VITE_ASSET__DwrXI$VF__"